<template>
  <div id="profile-page">
    <PageTitle title="Profile" />
    <b-container class="pb-5">
      <b-row>
        <b-col cols="12">
          <div class="wrapper dash-card bg-white">
            <div class="p-4">
              <img
                class="shadow-xl"
                style="width:100px;height:100px;border-radius:50%;border:5px solid #fff"
                :src="
                userObj.photourl ||
                  `https://ui-avatars.com/api/?name=${userObj.firstname}+${userObj.lastname}&rounded=true&size=256`
              "
                id="user-logo"
              />
              <p
                style="text-decoration:underline; cursor: pointer"
                v-b-modal.profile-pic-input
              >Change Photo</p>
              <b-button
                size="sm"
                v-b-modal.change-password-modal
                class
              >Change Password</b-button>
            </div>
            <hr class="mt-0" />
            <div class="px-4">
              <h5 class="mb-0">Personal Data</h5>
            </div>
            <b-form @submit="submit" @input="formInput">
              <div class="p-4">
                <b-form-group
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="First Name"
                  :invalid-feedback="formErrors.firstname"
                  :state="fieldState.firstname"
                >
                  <b-form-input
                    required
                    id="firstname"
                    v-model="profile.firstname"
                    :state="fieldState.firstname"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="Last Name"
                  :invalid-feedback="formErrors.lastname"
                  :state="fieldState.lastname"
                >
                  <b-form-input
                    required
                    id="lastname"
                    v-model="profile.lastname"
                    :state="fieldState.lastname"
                  ></b-form-input>
                </b-form-group>
              </div>
              <hr class="mt-0" />
              <div class="px-4" style="padding-bottom:20px">
                <h5>Next Of Kin</h5>
                <b-form-group
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="Full Name"
                  :invalid-feedback="formErrors.nextofkin"
                  :state="fieldState.nextofkin"
                >
                  <b-form-input
                    required
                    id="nextofkin"
                    v-model="profile.nextofkin"
                    :state="fieldState.nextofkin"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="Email Address"
                  :invalid-feedback="formErrors.nextofkinemail"
                  :state="fieldState.nextofkinemail"
                >
                  <b-form-input
                    required
                    id="nextofkinemail"
                    type="email"
                    v-model="profile.nextofkinemail"
                    :state="fieldState.nextofkinemail"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="Phone Number"
                  :invalid-feedback="formErrors.nextofkinphonenumber"
                  :state="fieldState.nextofkinphonenumber"
                >
                  <b-form-input
                    required
                    id="nextofkinphonenumber"
                    type="tel"
                    v-model="profile.nextofkinphonenumber"
                  ></b-form-input>
                </b-form-group>
                <StatefulButton
                  :error="error"
                  :loading="submitting"
                  text="Update Profile"
                  loadingText="Updating..."
                  elementClass="bg-orange"
                />
              </div>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <ChangePassword />
    <ChangePhoto />
  </div>
</template>

<script>
import PageTitle from "@/components/ui/PageTitle";
import StatefulButton from "@/components/actions/StatefulButton.vue";
import ChangePassword from "./components/ChangePassword";
import ChangePhoto from "./components/ChangePhoto";

import { validateRequired, checkFormErrors } from "@/utils/validators";
import { UserService } from "@/services";
import { mapState } from "vuex";

export default {
  data() {
    return {
      profile: {},
      formErrors: {},
      error: false,
      submitting: false
    };
  },
  components: {
    ChangePassword,
    PageTitle,
    StatefulButton,
    ChangePhoto
  },
  created() {
    const data = this.$route.meta.__data;
    this.profile = data;
  },
  computed: {
    ...mapState(["userObj"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        await UserService.updateProfile(this.profile);
        this.$store.dispatch("toast", {
          message: "We've updated your profile"
        });
      } catch (err) {
        this.formErrors = err;
        this.error = true;
      } finally {
        this.submitting = false;
      }
    },
    validateForm() {
      const {
        firstname,
        lastname,
        nextofkin,
        nextofkinemail,
        nextofkinphonenumber
      } = this.profile;
      const { errors, valid } = validateRequired({
        firstname,
        lastname,
        nextofkin,
        nextofkinemail,
        nextofkinphonenumber
      });
      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    }
  },
  async beforeRouteEnter(to, from, next) {
    const { profile } = await UserService.getProfile();
    to.meta.__data = profile;
    next();
  }
};
</script>
